import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appPreventHtmlTags]',
  standalone: false
})
export class PreventHtmlTagsDirective {
  
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.key === '<' || event.key === '>' || event.key === '&') {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: any) {
    const clean = event.target.value.replace(/<[^>]*>/g, '');
    if (event.target.value !== clean) {
      event.target.value = clean;
    }
  }
}
